export default __webpack_public_path__ + "static/media/robot_arm_lg.f25cadce.jpg";